import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { EvCore } from "ev-core";
import { ICommercialSale } from "src/models/commercial/ICommercialSale";

@Component({
    selector: "commercial-map-marker",
    imports: [CommonModule, EvCore],
    templateUrl: "./commercial-map-marker.component.html",
    styleUrls: ["./commercial-map-marker.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommercialMapMarkerComponent {
    readonly data = input<ICommercialSale | null>(null);
    validArea = computed(() => this.data()?.grossArea || this.data()?.usableArea);
    price = computed(() =>
        this.data()?.askingPrice > 0 ? this.data().askingPrice : this.data()?.salesPrice > 0 ? this.data().salesPrice : null
    );
}
